'use strict';

var defaultTheme = require('./defaultTheme-ea44e34a.js');
var React = require('react');
var styled = require('styled-components');
var Popover = require('./Popover-569cd272.js');
var ContextMenu = require('./ContextMenu-4ec3d9f3.js');
var expandMore = require('./expand-more-94585605.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28;
var Button$1 = styled__default['default'].button.attrs(defaultTheme.applyDefaultTheme)(_templateObject || (_templateObject = defaultTheme._taggedTemplateLiteral(["\n  position: relative;\n  border-radius: 3px;\n  font-family: inherit;\n  font-size: 0.875rem;\n  font-weight: 400;\n  padding: 12px 16px;\n  cursor: pointer;\n  background: ", ";\n  border: 2px solid ", ";\n  transition: all 250ms, opacity 200ms;\n\n  &:hover,\n  &.dropdown-is-active {\n    background: #296c58;\n    border-color: #296c58;\n  }\n\n  ", "\n\n  && {\n    ", ";\n  }\n\n  && {\n    ", ";\n  }\n\n  && {\n    ", ";\n  }\n\n  && {\n    ", ";\n  }\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"])), function (props) {
  return props.theme.getColor('emerald-500');
}, function (props) {
  return props.theme.getColor('emerald-500');
}, function (props) {
  return props.theme.themeProp('color', props.theme.getColor('white'), props.theme.getColor('white'));
}, function (props) {
  return props.secondary && styled.css(_templateObject2 || (_templateObject2 = defaultTheme._taggedTemplateLiteral(["\n        background: ", ";\n        border-color: ", ";\n\n        ", "\n\n        &:hover,\n        &.dropdown-is-active {\n          background: ", ";\n          border-color: ", ";\n        }\n      "])), function (props) {
    return props.theme.getColor('gray-200');
  }, function (props) {
    return props.theme.getColor('gray-200');
  }, props.theme.themeProp('color', props.theme.getColor('gray-700'), props.theme.getColor('gray-700')), function (props) {
    return props.theme.getColor('gray-300');
  }, function (props) {
    return props.theme.getColor('gray-300');
  });
}, function (props) {
  return props.outlined && styled.css(_templateObject3 || (_templateObject3 = defaultTheme._taggedTemplateLiteral(["\n        background: transparent;\n        transition: none;\n\n        ", "\n\n        ", "\n\n        &:hover,\n        &.dropdown-is-active {\n          background-color: #296c58;\n\n          ", "\n\n          ", "\n        }\n      "])), props.theme.themeProp('border-color', props.theme.getColor('emerald-400'), props.theme.getColor('emerald-500')), props.theme.themeProp('color', props.theme.getColor('emerald-400'), props.theme.getColor('emerald-500')), props.theme.themeProp('border-color', props.theme.getColor('emerald-400'), '#296c58'), props.theme.themeProp('color', props.theme.getColor('gray-200'), props.theme.getColor('gray-200')));
}, function (props) {
  return props.outlined && props.secondary && styled.css(_templateObject4 || (_templateObject4 = defaultTheme._taggedTemplateLiteral(["\n        ", "\n\n        ", "\n\n        &:hover,\n        &.dropdown-is-active {\n          background: ", ";\n\n          ", "\n\n          ", "\n        }\n      "])), props.theme.themeProp('border-color', props.theme.getColor('gray-200'), props.theme.getColor('gray-700')), props.theme.themeProp('color', props.theme.getColor('gray-200'), props.theme.getColor('gray-700')), props.theme.getColor('gray-300'), props.theme.themeProp('border-color', props.theme.getColor('gray-300'), props.theme.getColor('gray-300')), props.theme.themeProp('color', props.theme.getColor('gray-700'), props.theme.getColor('gray-700')));
}, function (props) {
  return props.outlined && props.secondary && props.dropdownItems && styled.css(_templateObject5 || (_templateObject5 = defaultTheme._taggedTemplateLiteral(["\n        &:hover,\n        &.dropdown-is-active {\n          ", "\n        }\n      "])), props.theme.themeProp('border-color', props.theme.getColor('gray-300'), props.theme.getColor('gray-700')));
}, function (props) {
  return props.block && styled.css(_templateObject6 || (_templateObject6 = defaultTheme._taggedTemplateLiteral(["\n      width: 100%;\n    "])));
}, function (props) {
  return props.disabled && styled.css(_templateObject7 || (_templateObject7 = defaultTheme._taggedTemplateLiteral(["\n      opacity: 0.5;\n      cursor: not-allowed;\n      pointer-events: none;\n    "])));
}, function (props) {
  return props.size === 'x-small' && styled.css(_templateObject8 || (_templateObject8 = defaultTheme._taggedTemplateLiteral(["\n      padding: 1px 16px;\n      height: 24px;\n    "])));
}, function (props) {
  return props.size === 'small' && styled.css(_templateObject9 || (_templateObject9 = defaultTheme._taggedTemplateLiteral(["\n      padding: 6px 16px;\n    "])));
}, function (props) {
  return props.size === 'large' && styled.css(_templateObject10 || (_templateObject10 = defaultTheme._taggedTemplateLiteral(["\n      padding: 16px 16px;\n    "])));
}, function (props) {
  return props.singleAction && styled.css(_templateObject11 || (_templateObject11 = defaultTheme._taggedTemplateLiteral(["\n      display: flex;\n      align-items: center;\n      gap: 34px;\n      border-radius: 3px !important;\n      transition: all 250ms, opacity 200ms;\n    "])));
});
var ButtonContent = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject12 || (_templateObject12 = defaultTheme._taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transform: scale(1);\n  opacity: 1;\n  transition: all 200ms;\n\n  > svg {\n    width: 100%;\n    max-width: 16px;\n    max-height: 16px;\n    margin-right: 8px;\n\n    ", ";\n\n    ", ";\n  }\n\n  ", "\n\n  ", ";\n"])), function (props) {
  return props.size === 'small' && styled.css(_templateObject13 || (_templateObject13 = defaultTheme._taggedTemplateLiteral(["\n        max-width: 13px;\n        max-height: 13px;\n      "])));
}, function (props) {
  return props.size === 'x-small' && styled.css(_templateObject14 || (_templateObject14 = defaultTheme._taggedTemplateLiteral(["\n        max-width: 11px;\n        max-height: 11px;\n      "])));
}, function (props) {
  return props.$loading && styled.css(_templateObject15 || (_templateObject15 = defaultTheme._taggedTemplateLiteral(["\n      transform: scale(0.95);\n      opacity: 0;\n    "])));
}, function (props) {
  return props.singleAction && styled.css(_templateObject16 || (_templateObject16 = defaultTheme._taggedTemplateLiteral(["\n      svg {\n        width: 100% !important;\n        height: 100% !important;\n        margin-right: 24px;\n      }\n    "])));
});
var LoadingIndicator = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject17 || (_templateObject17 = defaultTheme._taggedTemplateLiteral(["\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n  padding: 4px;\n  background: inherit;\n  opacity: 0;\n  transition: opacity 200ms;\n  box-sizing: border-box;\n\n  ", "\n"])), function (props) {
  return props.$loading && styled.css(_templateObject18 || (_templateObject18 = defaultTheme._taggedTemplateLiteral(["\n      opacity: 1;\n    "])));
});
var LoadingIndicatorSvg = styled__default['default'].svg.attrs(defaultTheme.applyDefaultTheme)(_templateObject19 || (_templateObject19 = defaultTheme._taggedTemplateLiteral(["\n  height: 100%;\n  color: inherit;\n  transform: rotate(-88deg);\n"])));
var LoadingIndicatorSvgCircle = styled__default['default'].circle.attrs(defaultTheme.applyDefaultTheme)(_templateObject20 || (_templateObject20 = defaultTheme._taggedTemplateLiteral(["\n  transition: stroke-dashoffset 300ms linear;\n  stroke-dasharray: 113;\n"])));
var ButtonWrapper = styled__default['default'].span.attrs(defaultTheme.applyDefaultTheme)(_templateObject21 || (_templateObject21 = defaultTheme._taggedTemplateLiteral(["\n  white-space: nowrap;\n"])));
var MainButtonContainer = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject22 || (_templateObject22 = defaultTheme._taggedTemplateLiteral(["\n  display: inline-block;\n  button {\n    ", ";\n\n    ", ";\n  }\n"])), function (props) {
  return props.dropdownItems && styled.css(_templateObject23 || (_templateObject23 = defaultTheme._taggedTemplateLiteral(["\n        border-bottom-right-radius: 0;\n        border-top-right-radius: 0;\n      "])));
}, function (props) {
  return props.dropdownItems && props.outlined && styled.css(_templateObject24 || (_templateObject24 = defaultTheme._taggedTemplateLiteral(["\n        border-right: none;\n      "])));
});
var MainButtonContainerSingle = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject25 || (_templateObject25 = defaultTheme._taggedTemplateLiteral(["\n  display: inline-block;\n  ", ";\n\n  button {\n    ", ";\n  }\n"])), function (props) {
  return props.singleAction && styled.css(_templateObject26 || (_templateObject26 = defaultTheme._taggedTemplateLiteral(["\n      display: flex;\n      align-items: center;\n      border-radius: 3px !important;\n      transition: all 250ms, opacity 200ms;\n    "])));
}, function (props) {
  return props.dropdownItems && styled.css(_templateObject27 || (_templateObject27 = defaultTheme._taggedTemplateLiteral(["\n        border-bottom-right-radius: 0;\n        border-top-right-radius: 0;\n      "])));
});
var DropdownButtonContainer = styled__default['default'].div.attrs(defaultTheme.applyDefaultTheme)(_templateObject28 || (_templateObject28 = defaultTheme._taggedTemplateLiteral(["\n  display: inline-block;\n\n  button {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n\n    ", ";\n  }\n\n  svg {\n    color: inherit;\n    height: 7px;\n    width: 12px;\n\n    ", ";\n  }\n"])), function (props) {
  return !props.singleAction && 'border-left: none';
}, function (props) {
  return !props.singleAction && 'margin-bottom: 1px';
});

var Button = React__default['default'].forwardRef(function Button(_ref, forwardedRef) {
  var onClickEffect = _ref.onClickEffect,
      singleAction = _ref.singleAction,
      dropdownItems = _ref.dropdownItems,
      secondary = _ref.secondary,
      outlined = _ref.outlined,
      block = _ref.block,
      icon = _ref.icon,
      size = _ref.size,
      disabled = _ref.disabled,
      loading = _ref.loading,
      className = _ref.className,
      children = _ref.children,
      props = defaultTheme._objectWithoutProperties(_ref, ["onClickEffect", "singleAction", "dropdownItems", "secondary", "outlined", "block", "icon", "size", "disabled", "loading", "className", "children"]);

  var _useState = React.useState(loading || false),
      _useState2 = defaultTheme._slicedToArray(_useState, 2),
      loadingState = _useState2[0],
      setLoadingState = _useState2[1];

  var _useState3 = React.useState(113),
      _useState4 = defaultTheme._slicedToArray(_useState3, 2),
      loadingStep = _useState4[0],
      setLoadingStep = _useState4[1];

  var loadingInterval = React.useRef(0);

  var _useState5 = React.useState(false),
      _useState6 = defaultTheme._slicedToArray(_useState5, 2),
      dropdownIsActive = _useState6[0],
      setDropdownIsActive = _useState6[1];

  var enableLoading = function enableLoading() {
    loadingInterval.current = setInterval(function () {
      setLoadingStep(function (currentLoadingStep) {
        var newLoadingStep = Math.round(currentLoadingStep - 15 * currentLoadingStep / 100);

        if (newLoadingStep === currentLoadingStep) {
          clearInterval(loadingInterval.current);
        }

        return newLoadingStep;
      });
    }, 300);
    setLoadingState(true);
  };

  var disableLoading = function disableLoading() {
    clearInterval(loadingInterval.current);
    setLoadingStep(0);
    setTimeout(function () {
      setLoadingState(false);
      setLoadingStep(113);
    }, 500);
  };

  React.useEffect(function () {
    if (loading) {
      enableLoading();
    } else {
      disableLoading();
    }

    return function () {
      return clearInterval(loadingInterval.current);
    };
  }, [loading]);

  var handleDropdownButtonClick = function handleDropdownButtonClick() {
    setDropdownIsActive(true);
  };

  var handleDropdownClose = function handleDropdownClose() {
    setDropdownIsActive(false);
  };

  return React__default['default'].createElement(ButtonWrapper, null, !singleAction ? React__default['default'].createElement(React__default['default'].Fragment, null, React__default['default'].createElement(MainButtonContainer, {
    dropdownItems: dropdownItems,
    secondary: secondary,
    outlined: outlined
  }, React__default['default'].createElement(Button$1, defaultTheme._extends({
    ref: forwardedRef,
    onClick: onClickEffect,
    singleAction: singleAction,
    dropdownItems: dropdownItems,
    secondary: secondary,
    outlined: outlined,
    block: block,
    size: size,
    disabled: disabled,
    className: className,
    "aria-busy": disabled
  }, props), React__default['default'].createElement(ButtonContent, {
    $loading: loadingState,
    size: size
  }, icon, children), React__default['default'].createElement(LoadingIndicator, {
    $loading: loadingState,
    style: {
      opacity: loadingState ? 1 : 0
    }
  }, React__default['default'].createElement(LoadingIndicatorSvg, {
    viewBox: "22 22 44 44"
  }, React__default['default'].createElement(LoadingIndicatorSvgCircle, {
    cx: "44",
    cy: "44",
    r: "18",
    fill: "none",
    strokeWidth: "4",
    stroke: "currentColor",
    style: {
      strokeDashoffset: "".concat(loadingStep, "px")
    }
  }))))), dropdownItems && React__default['default'].createElement(DropdownButtonContainer, {
    dropdownItems: dropdownItems,
    secondary: secondary,
    outlined: outlined
  }, React__default['default'].createElement(Popover.Popover, {
    content: React__default['default'].createElement(ContextMenu.ContextMenu, null, dropdownItems),
    placement: 'bottom-end',
    arrow: false,
    contextMenu: true,
    onHide: handleDropdownClose
  }, React__default['default'].createElement(Button$1, {
    ref: forwardedRef,
    singleAction: singleAction,
    dropdownItems: dropdownItems,
    secondary: secondary,
    outlined: outlined,
    block: block,
    size: size,
    disabled: disabled,
    onClick: handleDropdownButtonClick,
    className: dropdownIsActive ? 'dropdown-is-active' : ''
  }, React__default['default'].createElement(expandMore.SvgExpandMore, null))))) : React__default['default'].createElement(React__default['default'].Fragment, null, React__default['default'].createElement(MainButtonContainerSingle, {
    dropdownItems: dropdownItems,
    secondary: secondary,
    outlined: outlined,
    className: className
  }, React__default['default'].createElement(DropdownButtonContainer, {
    singleAction: singleAction
  }, React__default['default'].createElement(Popover.Popover, {
    content: React__default['default'].createElement(ContextMenu.ContextMenu, null, dropdownItems),
    placement: 'bottom-end',
    arrow: false,
    contextMenu: true,
    onHide: handleDropdownClose
  }, React__default['default'].createElement(Button$1, {
    ref: forwardedRef,
    singleAction: singleAction,
    dropdownItems: dropdownItems,
    secondary: secondary,
    outlined: outlined,
    block: block,
    size: size,
    disabled: disabled,
    onClick: handleDropdownButtonClick,
    className: dropdownIsActive ? 'dropdown-is-active' : ''
  }, React__default['default'].createElement(ButtonContent, {
    $loading: loadingState,
    size: size,
    singleAction: singleAction
  }, icon, children), React__default['default'].createElement(expandMore.SvgExpandMore, null)))))));
});
Button.propTypes = process.env.NODE_ENV !== "production" ? {
  onClickEffect: defaultTheme.PropTypes.func,
  singleAction: defaultTheme.PropTypes.bool,
  dropdownItems: defaultTheme.PropTypes.node,
  secondary: defaultTheme.PropTypes.bool,
  outlined: defaultTheme.PropTypes.bool,
  block: defaultTheme.PropTypes.bool,
  icon: defaultTheme.PropTypes.element,
  size: defaultTheme.PropTypes.oneOf(['x-small', 'small', 'normal', 'large']),
  disabled: defaultTheme.PropTypes.bool,
  loading: defaultTheme.PropTypes.bool,
  className: defaultTheme.PropTypes.string,
  children: defaultTheme.PropTypes.any.isRequired
} : {};
Button.defaultProps = {
  size: 'normal',
  singleHover: false
};

exports.Button = Button;
